import {useContext} from 'react';
import {IpDetailsContext, ContextProps} from './ipDetails';

export function useIpDetails(): ContextProps {
  const context = useContext(IpDetailsContext);
  if (context === undefined) {
    throw new Error('IpDetails must be used within an IpDetailsProvider');
  }
  return context;
}
